import React from 'react';
import {FormGroup, TagInput} from '@blueprintjs/core';

import SelectRecipients from '../../SelectRecipients';

interface RecipientsProps {
  to: string,
  cc: string | null,
  bcc: string | null,
  onChange: (type: string) => (value: string[]) => void;
  disabled?: boolean;
  preview?: boolean;
}

interface RecipientFormGroupProps {
  label: string;
  value: any;
  onChange: (value: string[]) => void;
  disabled?: boolean;
  preview?: boolean;
  forceDefault?: boolean;
}

const toRecipientsList = (recipients: string | null): string[] => {
  if (recipients && recipients.length > 0) {
    return recipients.split(',');
  }
  return [];
}

const PreviewElement = ({value}: any) => {
  return (
    <TagInput
      values={value || []}
      onChange={() => {}}
      disabled={true}
    />
  );
};

const RecipientFormGroup = ({
  label,
  value,
  onChange,
  disabled,
  forceDefault = false,
  preview,
}: RecipientFormGroupProps) => {
  return (
    <FormGroup label={label} className="email-input">
      {/* hide / show using CSS so that we don't cause re-render */}
      <div className={"preview " + (preview ? 'show' : '')}>
        <PreviewElement
          value={toRecipientsList(value)}
        />
      </div>
      <div className={"select-input " + (preview ? 'hide' : '')}>
        <SelectRecipients
          defaultValue={toRecipientsList(value)}
          onChange={onChange}
          forceDefault={forceDefault}
          disabled={disabled}
        />
      </div>
    </FormGroup>
  );
};

const Recipients = ({
  to,
  cc,
  bcc,
  onChange,
  disabled = false,
  preview = false,
}: RecipientsProps) => {
  return (
    <div className="content__email__recipients">
      <RecipientFormGroup
        label="To"
        value={to}
        onChange={onChange('recipients')}
        preview={preview}
        disabled={disabled}
      />
      <RecipientFormGroup
        label="CC"
        value={cc}
        onChange={onChange('cc')}
        disabled={disabled}
        preview={preview}
      />
      <RecipientFormGroup
        label="BCC"
        value={bcc}
        onChange={onChange('bcc')}
        disabled={disabled}
        preview={preview}
      />
    </div>
  )
};

export default Recipients;
